"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REGISTER_BUTTON = exports.LOGIN_BUTTON = exports.BUTTONS = void 0;
const BUTTONS = exports.BUTTONS = 'buttons';
const REGISTER_BUTTON = exports.REGISTER_BUTTON = 'register-button';
const LOGIN_BUTTON = exports.LOGIN_BUTTON = 'login-button';
